module.exports = __webpack_public_path__ + "static/team-min-f5ec3b521889cb752dc2aeb5fe621f54.jpg";